import { faExternalLinkAlt, faFileInvoiceDollar } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Modal, Space } from "antd"

type Props = {
  isOpen: boolean
  onClose: () => void
  qboInvoiceUrl: string
}

const ExportConfirmationModal = ({ isOpen, onClose, qboInvoiceUrl }: Props) => {
  return <Modal
    open={isOpen}
    okText="Open in QuickBooks Online"
    onOk={() => window.open(qboInvoiceUrl, "_blank")}
    okButtonProps={{icon: <FontAwesomeIcon icon={faExternalLinkAlt}/>, hidden: qboInvoiceUrl === ''}}
    cancelText="Close"
    onCancel={() => onClose()}
    title={<Space><FontAwesomeIcon icon={faFileInvoiceDollar}/> Invoice Created</Space>}
  >
    <span>Invoice has been generated.</span>
  </Modal>
}

export default ExportConfirmationModal